module.exports = __webpack_public_path__ + "img/confirm-banner.62abc260.jpg";